import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { getMemoryList } from 'store/memory-actions';

import Loading from 'components/UI/Loading/Loading';
import Memory from 'components/tribut/MemorySection/Memory/Memory';

import classes from './MemoryPage.module.css';

const MemoryPage = () => {
  const navigate = useNavigate();
  const [memoryData, setMemoryData] = useState(null);
  const [loading, setLoading] = useState(true);
  let params = useParams();
  let tributId = params.tributId ? params.tributId : 73;
  let memoryId = params.idMemory ? params.idMemory : '';
  const dispatch = useDispatch();
  const dataMemories = useSelector(state => state.memoriesData);

  useEffect(() => {
    ReactGA.initialize('G-N3MP6T91TP');
    ReactGA.pageview(`/tribut/${tributId}/memory/${memoryId}`);
  }, []);

  useEffect(() => {
    const cachedForTribut = dataMemories.byTributId?.[tributId];
    if (!cachedForTribut) {
      dispatch(getMemoryList(tributId));
    }
  }, [dispatch, tributId]);

  useEffect(() => {
    const memoriesForCurrentTribut =
      dataMemories.byTributId?.[tributId] || dataMemories.data;
    if (memoriesForCurrentTribut) {
      if (memoriesForCurrentTribut === 'error') {
        setLoading(false);
        setMemoryData('error');
      } else if (
        Array.isArray(memoriesForCurrentTribut) &&
        memoriesForCurrentTribut.length > 0
      ) {
        setLoading(false);
        const found = memoriesForCurrentTribut.find(
          memory => parseInt(memoryId) === memory.memoryId
        );
        if (found) {
          setMemoryData(found);
        }
      }
    }
  }, [dataMemories, tributId, memoryId]);

  return (
    <>
      {!loading ? (
        <>
          {memoryData === 'error' ? (
            <p>No hay memoria</p>
          ) : (
            <section
              className={classes.TributContainer}
              id="allMemories"
            >
              <div className={classes.allMemoriesContainer}>
                {memoryData && (
                  <>
                    <Button
                      component={Link}
                      to={
                        tributId !== 73
                          ? `/tribut/${tributId}/memorias`
                          : '/alvaro'
                      }
                      className={classes.btnBack}
                    >
                      <ArrowBackIcon
                        className={classes.btnBackIcon}
                      />
                    </Button>
                    <p className={classes.title}>Memorias</p>
                    <Memory
                      dataMemory={memoryData}
                      tributId={tributId}
                      memoryView={parseInt(memoryId)}
                      onDeleteMemory={() => {
                        navigate(
                          tributId !== 73
                            ? `/tribut/${tributId}/memorias`
                            : '/alvaro'
                        );
                      }}
                    />
                  </>
                )}
              </div>
            </section>
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default MemoryPage;
